<template>
    <div v-show="modelValue" class="fixed top-0 w-full h-full bg-transparent-basic-3 z-[80] flex justify-center items-center">
        <div
            class="w-[300px] p-4 pb-5 bg-white rounded-3 overflow-hidden shadow-modal transform transition-all duration-200 flex flex-col items-center"
            :style="{ width }"
        >
            <!-- Title Slot (optional) -->
            <slot name="title" v-if="$slots.title"></slot>
            <p v-else-if="showTitle" class="mt-2 font-body-md-medium">{{ title }}</p>

            <!-- Body Slot with fallback to confirmDescription -->
            <slot>
                <div class="mt-2 text-center">
                    <p class="font-body-sm-regular text-content-basic-2">{{ confirmDescription }}</p>
                </div>
            </slot>

            <!-- Footer Slot (buttons) with safe default -->
            <slot name="footer">
                <div class="mt-4 flex justify-center gap-2 w-full">
                    <DesignButton
                        v-if="showCancel"
                        class="w-full"
                        :btnText="cancelText"
                        btnSize="MD"
                        :btnType="cancelBtnType"
                        :btnDisabled="false"
                        @click-event="clickCancel"
                    />
                    <DesignButton
                        class="w-full"
                        :btnText="buttonText"
                        btnSize="MD"
                        :btnType="confirmBtnType"
                        :btnDisabled="false"
                        @click-event="clickConfirm"
                    />
                </div>
            </slot>
        </div>
    </div>
</template>

<script setup>
import { defineProps, defineEmits } from 'vue';
import DesignButton from '@/components/design-system/design-button.vue';

const props = defineProps({
    modelValue: Boolean,
    title: { type: String, default: 'Confirm' },
    showTitle: { type: Boolean, default: false },
    confirmDescription: String,
    buttonText: String,
    showCancel: { type: Boolean, default: false },
    cancelText: { type: String, default: 'Cancel' },
    confirmBtnType: { type: String, default: 'PRIMARY' },
    cancelBtnType: { type: String, default: 'QUATERNARY' },
    hasAfterConfirm: {
        type: Boolean,
        default: false,
    },
    // width of the popup content (e.g. '26rem', '480px')
    width: {
        type: String,
        default: '26rem',
    },
});

const emit = defineEmits(['update:modelValue', 'after-confirm', 'cancel']);

function clickConfirm() {
    if (props.hasAfterConfirm) {
        emit('after-confirm');
    } else {
        emit('update:modelValue', false);
    }
}

function clickCancel() {
    emit('cancel');
    emit('update:modelValue', false);
}
</script>
